import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Technologies We Use</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Delivering optimal technology talent across diverse languages, we
              provide the right professionals for mobile app support, ensuring
              added value through cutting-edge technology proficiency.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="iOS Apps">
              <ul>
                <li>Swift</li>
                <li>Objective-C</li>
                <li>SwiftUI</li>
                <li>CocoaPods</li>
                <li>RxSwift</li>
                <li> SwiftLint</li>
                <li>CircleCI</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Android Apps">
              <ul>
                <li>Kotlin</li>
                <li>Java</li>
                <li>Gradle</li>
                <li>Dagger2</li>
                <li>JetPack</li>
                <li>Coroutines</li>
                <li>Fastlane</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Cross-platform Apps">
              <ul>
                <li>React Native</li>
                <li>Flutter</li>
                <li>Native Script</li>
                <li>Javascript</li>
                <li>TypeScript</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Progressive Web Apps">
              <ul>
                <li>React</li>
                <li>Angular</li>
                <li> Redux</li>
                <li>Polymer</li>
                <li> Workbox</li>
                <li> Lighthouse</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
